import React, { Component } from "react";

import FormItemsInlineGroup from "../../../../shared/items/static/formItemsInlineGroup";
import FormItemsInline from "../../../../shared/items/static/formItemsInline";
import FormItem from "../../../../shared/items/static/formItem";
import InputDate from "../../../../shared/items/contols/inputDate";
import InputTime from "../../../../shared/items/contols/inputTime";
import { withLogisticReports } from "../../../../shared/containers/containerLogisticReport";

class TimeRangeLogisticReport extends Component {
  render() {
    const { onHandleChangeStore, valueStore } = this.props;

    return (
      <FormItemsInlineGroup>
        <FormItemsInline>
          <FormItem title="Начальная Дата">
            <InputDate
              name="reportStartDate"
              onHandleChangeStore={onHandleChangeStore.bind(this, "reportStartDate")}
              valueStore={valueStore}
              maxDate={new Date()}
            />
          </FormItem>

          <FormItem title="Начальное Время">
            <InputTime
              name="reportStartTime"
              onHandleChangeStore={onHandleChangeStore.bind(this, "reportStartTime")}
              valueStore={valueStore}
            />
          </FormItem>
        </FormItemsInline>

        <FormItemsInline>
          <FormItem title="Конечная Дата">
            <InputDate
              name="reportEndDate"
              onHandleChangeStore={onHandleChangeStore.bind(this, "reportEndDate")}
              valueStore={valueStore}
              minDate={valueStore.reportStartDate}
            />
          </FormItem>

          <FormItem title="Конечное Время">
            <InputTime name="reportEndTime" onHandleChangeStore={onHandleChangeStore.bind(this, "reportEndTime")} valueStore={valueStore} />
          </FormItem>
        </FormItemsInline>
      </FormItemsInlineGroup>
    );
  }
}

export default withLogisticReports(React.memo(TimeRangeLogisticReport));
